import React, { useEffect, useState } from 'react'
import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import '../../../../assets/css/partials/status-diagram.css'
import DateRange from '@/components/partials/DateRange'
import moment from 'moment'

export default function ManualOverview({
    endpoint = 'dashboard/manuals/overview',
    title = 'Ръководства',
    colors = ['#5563FF', '#C084FC', '#374151'],
    donut = true,
    size = 220
}) {
    const [state, setState] = useState({ loading: true, data: null })
    const [dateRange, setDateRange] = useState({
        from: moment().subtract(30, 'days').toISOString().split('T')[0],
        to: moment().toISOString().split('T')[0]
    })

    const loadData = () => {
        setState(prev => ({ ...prev, loading: true }))
        const params = new URLSearchParams({
            date_from: dateRange.from,
            date_to: dateRange.to
        })

        Api.get(`${endpoint}?${params.toString()}`)
            .then(res => {
                const payload = res?.data ?? res
                setState({ loading: false, data: payload })
            })
            .catch(() => setState({ loading: false, data: null }))
    }

    useEffect(() => {
        loadData()
    }, [endpoint, dateRange])

    const handleDateChange = (field, value) => {
        setDateRange(prev => ({
            ...prev,
            [field]: value
        }))
    }

    // Convert API data format to items array
    const apiData = state.data || {}
    const sampleData = {
        manuals: 2,
        system_errors: 1,
        problems: 0
    }

    const dataSource = Object.keys(apiData).length > 0 ? apiData : sampleData

    // Convert object to items array
    const itemsSource = [
        { key: 'manuals', label: trans('nav.manuals'), value: dataSource.manuals || 0, color: "#4A3AFF" },
        { key: 'system_errors', label: trans('tabs.errors'), value: dataSource.system_errors || 0, color: "#C893FD" },
        { key: 'problems', label: trans('random.commonProblemsShort'), value: dataSource.problems || 0, color: "#1E1B39" }
    ]

    const items = itemsSource

    function getTotalResults() {
        return items.reduce((sum, it) => sum + Number(it.value || 0), 0)
    }

    return (
        <div className="manuals-chart">
            <div className='head'>
                <h3>{title}</h3>
                <DateRange
                    startDate={dateRange.from}
                    endDate={dateRange.to}
                    onStartDateChange={(date) => {
                        handleDateChange('from', date)
                    }} onEndDateChange={(date) => {
                        handleDateChange('to', date)
                    }}
                />
            </div>
            <hr />
            {state.loading ?
                <Skeleton height={200} count={1} />
                :
                getTotalResults() === 0 ?
                    <div
                        className="alert info"
                        style={{
                            marginBottom: 0
                        }}
                    >
                        {trans("messages.noDataFound")}
                    </div>
                    :
                    <div className="body">
                        <div className="bubble-chart">
                            {(() => {
                                const maxSize = 200
                                const minSize = 70
                                const sorted = [...items].sort((a, b) => Number(b.value) - Number(a.value))
                                const maxVal = Math.max(...sorted.map(i => Number(i.value)), 1)

                                const bubbles = sorted.map(it => {
                                    const ratio = Number(it.value) / maxVal
                                    const diameter = minSize + (maxSize - minSize) * Math.sqrt(ratio)
                                    return { ...it, diameter }
                                })

                                // Positions: largest left, medium top-right, smallest bottom-right
                                const positions = [
                                    { top: '10%', left: '0' },
                                    { top: '0', right: '0' },
                                    { bottom: '0', right: '5%' },
                                ]

                                return bubbles.map((b, idx) => (
                                    <div
                                        key={b.key}
                                        className="bubble"
                                        style={{
                                            width: b.diameter,
                                            height: b.diameter,
                                            backgroundColor: b.color,
                                            border: "4px solid #fff",
                                            ...positions[idx],
                                        }}
                                    >
                                        {b.value}
                                    </div>
                                ))
                            })()}
                        </div>

                        <ul>
                            {items.map((it, idx) => {
                                return (
                                    <li key={it.key || it.label || idx}>
                                        <span style={{ backgroundColor: it.color }} />
                                        {it.label}
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
            }
        </div>
    )
}